<template>
  <section class="table-wrap">
    <ve-table
      :fixed-header="true"
      scroll-width="90rem"
      :columns="columns"
      :table-data="tableData"
      :border-around="false"
      :sort-option="sortOption"
    />

    <empty-state
      v-if="showSearchEmptyState"
      :title="$t('CLOSING_REASONS.LIST.NOT_FOUND')"
    />

    <empty-state
      v-else-if="!isLoading && !items.length"
      :title="$t('CLOSING_REASONS.LIST.404')"
    />

    <div v-if="isLoading" class="item--loader">
      <spinner />
      <span>{{ $t('CLOSING_REASONS.LIST.LOADING_MESSAGE') }}</span>
    </div>
  </section>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { VeTable } from 'vue-easytable';

import Spinner from 'shared/components/Spinner.vue';
import WootButton from 'dashboard/components/ui/WootButton';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  components: {
    Spinner,
    WootButton,
    EmptyState,
    VeTable,
  },
  mixins: [clickaway, rtlMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showSearchEmptyState: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortConfig: {},
      sortOption: {
        sortAlways: true,
        sortChange: params => this.$emit('on-sort-change', params),
      },
    };
  },
  computed: {
    tableData() {
      if (this.isLoading) {
        return [];
      }

      return this.items;
    },
    columns() {
      return [
        {
          field: 'name',
          key: 'name',
          title: this.$t('CLOSING_REASONS.LIST.HEADER.NAME'),
          fixed: 'left',
          align: this.isRTLView ? 'right' : 'left',
          sortBy: this.sortConfig.name || '',
          width: 300,
        },
        {
          field: 'actions',
          key: 'actions',
          title: this.$t('CLOSING_REASONS.LIST.HEADER.ACTIONS'),
          align: 'center',
          width: 100,
          renderBodyCell: ({ row }) => {
            return (
              <WootButton
                variant="link"
                icon="dismiss-circle"
                color-scheme="secondary"
                onClick={() => this.$emit('on-delete-click', row)}
              >
                {this.$t('CLOSING_REASONS.DELETE.BUTTON_TEXT')}
              </WootButton>
            );
          },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/mixins';

.table-wrap {
  flex: 1 1;
  height: 100%;
  overflow: hidden;
}

.table-wrap::v-deep {
  .ve-table {
    padding-bottom: var(--space-large);

    .ve-table-container {
      overflow-y: hidden !important;
    }
  }

  .ve-table-header-th {
    padding: var(--space-small) var(--space-two) !important;
    font-size: var(--font-size-mini) !important;
  }

  .ve-table-body-td {
    padding: var(--space-small) var(--space-two) !important;

    a {
      font-weight: var(--font-weight-medium);
    }
  }

  .ve-table-sort {
    top: -4px;
  }
}

.item--loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-big);
}
</style>